module.exports = "<section>\n  <social-security-card ng-repeat=\"ssRow in $ctrl.ssData track by $index\" ss-data=\"ssRow\">\n  </social-security-card>\n\n  <div class=\"list-empty\" ng-if=\"$ctrl.isEmpty()\">\n    <span class=\"icon-warning\"></span>\n    <span>{{'SOCIAL_SECURITY.MAIN.EMPTY_LIST' | translate}}</span>\n  </div>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/social-security.module/features/socialSecurity/socialSecurityList/socialSecurityList.html
// module id = 2335
// module chunks = 0